/* eslint-disable max-classes-per-file */
export default class RetentionTemplateBuilder {
  constructor(build) {
    this.id = build.id;
    this.name = build.name;
    this.description = build.description;
    this.type = build.type;
    this.showAverage = build.showAverage;
    this.showMedian = build.showMedian;
    this.retentionQuery = build.retentionQuery;
  }

  static builder() {
    return new RetentionTemplateBuilder.Builder();
  }
}

RetentionTemplateBuilder.Builder = class {
  constructor() {
    this.obj = {};
  }

  id(id) {
    this.obj.id = id;
    return this;
  }

  name(name) {
    this.obj.name = name;
    return this;
  }

  description(description) {
    this.obj.description = description;
    return this;
  }

  type(type) {
    this.obj.type = type;
    return this;
  }

  showAverage(showAverage) {
    this.obj.showAverage = showAverage;
    return this;
  }

  showMedian(showMedian) {
    this.obj.showMedian = showMedian;
    return this;
  }

  retentionQuery(retentionQuery) {
    this.obj.retentionQuery = retentionQuery;
    return this;
  }

  build() {
    return new RetentionTemplateBuilder(this.obj);
  }
};
